__webpack_require__.p = "https://stage.myqg.org/";